import { render, staticRenderFns } from "./EventsPage.vue?vue&type=template&id=7d5d6f14&"
import script from "./EventsPage.vue?vue&type=script&lang=js&"
export * from "./EventsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports